import styled from "styled-components";
import { VirtualSpace } from "@lifeat/shared/data-models/virtual-space/VirtualSpace";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import { HorizontalDivider } from "@common/LifeAtDivider/LifeAtDivider";
import { LifeAtBodyPrimary } from "@common/LifeAtText/LifeAtText";
import { useVirtualSpaceContext } from "@contexts/VirtualSpaceContext";
import { SelectSpaceEvent } from "../../AmplitudeSpaceEvents";
import { SpaceList } from "./SpaceSelectionContent";
import SpaceThumbnail from "./SpaceThumbnail";

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px 0;
`;

const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const SectionContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const CategoryHeader = styled(LifeAtBodyPrimary)`
    font-weight: bolder;
`;

const FEATURED_SPACES_LABEL = "Featured Spaces";
const RECOMMENDED_SPACES_LABEL = "Recommended Spaces";

export default function DiscoverSpaces() {
    const { spaceController } = useVirtualSpaceContext();
    const amplitudeService = AmplitudeService.getInstance();

    const handleSelectSpace = (space: VirtualSpace) => {
        spaceController.playSpace(space);
        amplitudeService.logEvent(
            new SelectSpaceEvent(
                {
                    spaceId: space.id,
                    spaceName: space.name,
                    spaceCategory: space.category,
                    spaceCreator: space.creatorName,
                },
                "discover",
            ),
        );
    };

    return (
        <ListContainer>
            <SectionContainer>
                <CategoryHeader>{FEATURED_SPACES_LABEL}</CategoryHeader>
                <SectionContentContainer>
                    <SpaceList>
                        {spaceController.featuredSpaces.map((space) => (
                            <SpaceThumbnail
                                key={space.id}
                                space={space}
                                handleSelectSpace={() => handleSelectSpace(space)}
                            />
                        ))}
                    </SpaceList>
                </SectionContentContainer>
            </SectionContainer>
            <HorizontalDivider widthCssValue={"100%"} />
            <SectionContainer>
                <CategoryHeader>{RECOMMENDED_SPACES_LABEL}</CategoryHeader>
                <SpaceList>
                    {spaceController.recommendedSpaces.map((space) => {
                        return (
                            <SpaceThumbnail
                                key={space.id}
                                space={space}
                                handleSelectSpace={() => handleSelectSpace(space)}
                            />
                        );
                    })}
                </SpaceList>
            </SectionContainer>
        </ListContainer>
    );
}
